import React from 'react';
import {motion} from 'framer-motion';
import styled from 'styled-components';


const Wrapper = ({children}) => {
    return (
    
      <motion.div
      initial={{
        opacity: 0
      }}
      animate={{
        opacity: 1
      }}
      transition={{
        duration: 1,
        ease: "easeInOut"
      }}
  
      >
        {children}
      </motion.div>
 
    );
};

export default Wrapper;

